import React, { forwardRef } from 'react';
import InputBaseOrangeAsteriskVariant, { IInputProps } from 'component-library/atoms/InputBase/Variants/OrangeAsteriskVariant/InputBaseOrangeAsteriskVariant';

const InputZipCodeOrangeAsteriskVariant = forwardRef(
	(
		{
			className = '',
			value,
			...rest
		}: IInputProps,
		ref: any,
	) => {
		const formatZip = (zip: string) => {
			const onlyNumbers = zip.replace(/[^0-9]/g, '');
			return onlyNumbers;
		};

		const isZipValid = (val: string) => {
			return val.length === 5;
		};

		return (
			<InputBaseOrangeAsteriskVariant
				{...rest}
				type='tel'
				className={`InputZipCode ${className}`}
				value={value}
				ref={ref}
				formatValue={formatZip}
				maxLength={5}
				isValid={isZipValid}
				inputMode='numeric'
			/>
		);
	},
);
InputZipCodeOrangeAsteriskVariant.displayName = 'InputZipCode';

export default InputZipCodeOrangeAsteriskVariant;
